module.exports = __webpack_public_path__ + "static/media/92.3699a464.png";